import styled from 'styled-components'
import { ScrollIntoView } from '@/features/shared/components/ScrollIntoView'
import { trackFilterUtilityViewed } from '@/features/shared/analytics/filters'
import { DISPLAY_FORMAT } from '@/features/shared/constants/analytics'
import { type SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'

type Props = {
  facet: SEARCH_FILTER_TYPE
  index: number
  children: React.ReactNode
  isDropdown?: boolean
}

export const FilterScrollWrapper = ({ facet, index, children, isDropdown }: Props) => {
  const handleOnInView = () => {
    trackFilterUtilityViewed({
      list_index: index,
      filter_value: facet,
      utility_type: isDropdown ? 'dropdown' : 'filter',
      display_format: DISPLAY_FORMAT.HORIZONTAL,
    })
  }
  return <ScrollInView onInView={handleOnInView}>{children}</ScrollInView>
}

const ScrollInView = styled(ScrollIntoView)`
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
`
